<template>
  <div
    :class="{
      'octadesk-chat-attachment': !isQuote,
      'octadesk-chat-quote-attach': isQuote
    }"
    :style="attachSize"
  >
    <a
      v-if="isImage"
      class="chat-attachment"
      :href="attachment.url"
      download="true"
      target="_system"
      :style="attachSize"
    >
      <img :src="attachment.url" :alt="attachment.name" />
    </a>

    <audio v-else-if="isAudio" ref="attachAudio" controls :style="attachSize">
      <source :src="attachment.url" :type="`audio/${audioType}`" />
    </audio>

    <div v-else-if="isVideo" class="chat-attachment" :style="attachSize">
      <video ref="attachVideo" controls :style="attachSize">
        <source :src="attachment.url" />
      </video>
    </div>

    <div v-else class="chat-attachment">
      <a :href="attachment.url" target="_system" :style="attachSize">
        <svg
          v-if="isQuote"
          viewBox="0 0 1100 1100"
          width="16"
          height="16"
          style="float: left; margin: 5px"
        />

        <p v-if="!isQuote" class="chat-attachment-name space-top-xs">
          <i
            class="icon-file-type space-right-xs"
            :class="parseExtension(attachment.url)"
          ></i>
          {{ attachment.name }}
        </p>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      attachment: {
        type: Object,
        required: true
      },
      width: {
        type: String,
        required: false,
        default: undefined
      },
      height: {
        type: String,
        required: false,
        default: undefined
      },
      isQuote: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      isImage() {
        return this.parseExtension(this.attachment.url.toLowerCase()).match(
          /(jpg|jpeg|png|gif|web|svg)$/
        )
      },
      audioType() {
        const extension = this.parseExtension(this.attachment.url.toLowerCase())

        if (extension === 'opus') return 'ogg'

        if (extension === 'mp3') return 'mpeg'

        return extension
      },
      isAudio() {
        return this.parseExtension(this.attachment.url.toLowerCase()).match(
          /(mp3|ogg|wav|opus)$/
        )
      },
      isVideo() {
        return this.parseExtension(this.attachment.url.toLowerCase()).match(
          /(mp4|webM)$/
        )
      },
      attachSize() {
        return this.height && this.width
          ? `height: ${this.height}; width: ${this.width};`
          : null
      },
      attachIconSize() {
        return this.height && this.width
          ? `height: ${this.height}; width: ${this.width};`
          : null
      }
    },
    methods: {
      parseExtension(url) {
        return url.split('.')[url.split('.').length - 1]
      }
    }
  }
</script>

<style lang="scss">
  .chat-attachment-name {
    i {
      float: left;
    }
  }

  img,
  video {
    max-height: 100%;
    max-width: 100%;
  }
  audio {
    width: 19em;
  }

  .icon-file-type-quote {
    background-size: 610% 280%;
    // default file icon
    background-position: -208px -57px;
    // first row
    &.ppt,
    &.pptx {
      // --ok
      background-position: 5px 0 !important;
    }
    &.txt {
      // --ok
      background-position: -65px 0 !important;
    }
    &.doc,
    &.docx {
      // --ok
      background-position: -139px 0 !important;
    }
    &.html {
      // --ok
      background-position: -210px 0 !important;
    }
    &.rtf {
      // --ok
      background-position: -281px 0 !important;
    }
    &.avi {
      // --ok
      background-position: -352px 0 !important;
    }
    &.pdf {
      // --ok
      background-position: -423px 0 !important;
    }
    // second row
    &.mp4 {
      // --ok
      background-position: 5px -57px !important;
    }
    &.zip {
      // --ok
      background-position: -66px -57px !important;
    }
    &.xls,
    &.xlsx {
      // --ok
      background-position: -137px -57px !important;
    }
    &.exe {
      // --ok
      background-position: -279px -57px !important;
    }
    &.svg {
      // --ok
      background-position: -350px -57px !important;
    }
    &.mp3 {
      // --ok
      background-position: -421px -57px !important;
    }
    // third row
    &.msg {
      // --ok
      background-position: 5px -115px !important;
    }
    &.csv {
      // --ok
      background-position: -66px -115px !important;
    }
    &.xml {
      background-position: -137px -115px !important;
    }
  }

  .octadesk-chat-quote-attach img {
    height: 100%;
  }
</style>
